import React from "react";

function About(){
    return (
        <div className="flex justify-center mt-10 mb-20 bg-opacity-5" >
            <div className="w-[500px] sm:w-4/5 md:w-3/5 lg:w-2/5 text-center m-2 rounded-md shadow-xl shadow-black" style={{backgroundColor: "rgba(34,38,41,0.1)"}}>
            <h1 className="font-extrabold text-5xl lg:text-4xl md:text-3xl sm:text-2xl italic mt-5">What is a Hackathon</h1>
                <p className=" text-justify p-5 lg:text-lg text-gray-400">A hackathon is an event where you'll have the opportunity to collaborate with like-minded individuals, showcase your skills, and potentially walk away with prizes and recognition. Whether you're a seasoned developer, designer, or a first-time hacker, this event is open to all and promises to be a great learning experience. Don't miss out on this chance to push the boundaries of what's possible and create something truly remarkable.</p>
            </div>
        </div>
    )
}

export default About;